import React from 'react';
import { parseProps, parsePropsTypes } from '@ktag/styleguide/dist/util';
import { createRoot } from 'react-dom/client';
import App, { AppProps } from './App';

Array.prototype.forEach.call(
  document.querySelectorAll('[data-jobportal]'),
  (element: HTMLDivElement) => {
    // Enforce shadowDom for testing purposes
    // if (element.dataset.standalone !== 'true' && !element.shadowRoot) {
    //   element.attachShadow({ mode: 'open' });
    // }

    const props = parseProps<AppProps>(element.dataset, [
      {
        key: 'mocked',
        type: parsePropsTypes.bool,
      },
      {
        key: 'standalone',
        type: parsePropsTypes.bool,
      },
      {
        key: 'title',
        type: parsePropsTypes.string,
      },
      {
        key: 'moreLink',
        type: parsePropsTypes.string,
      },
      {
        key: 'maxEntries',
        type: parsePropsTypes.int,
      },
      {
        key: 'api',
        type: parsePropsTypes.string,
      },
      {
        key: 'newThresholdHours',
        type: parsePropsTypes.string,
      },
      {
        key: 'careerUrl',
        type: parsePropsTypes.string,
      },
      {
        key: 'volksschuleUrl',
        type: parsePropsTypes.string,
      },
      {
        key: 'apprenticeshipUrl',
        type: parsePropsTypes.string,
      },
      {
        key: 'listOnly',
        type: parsePropsTypes.bool,
      },
      {
        key: 'preFilter',
        type: parsePropsTypes.json,
      },
      {
        key: 'filterJobIds',
        type: parsePropsTypes.json,
      },
      {
        key: 'translationApiUrl',
        type: parsePropsTypes.string,
        datasetKey: 'translationApi',
      },
      {
        key: 'translationMissingApiUrl',
        type: parsePropsTypes.string,
        datasetKey: 'translationMissingApi',
      },
      {
        key: 'privacyUrl',
        type: parsePropsTypes.string,
        datasetKey: 'privacyUrl',
      },
      {
        key: 'loginUrl',
        type: parsePropsTypes.string,
        datasetKey: 'loginUrl',
      },
    ]);

    if (props.api) {
      const root = element.shadowRoot
        ? createRoot(element.shadowRoot)
        : createRoot(element);

      root.render(React.createElement(App, { rootElement: element, ...props }));
    }
  },
);
